import { MenuBar, SideBar, Footer, SetLiveNotification } from "Components";
import styled, { css } from "styled-components";
import { useDesktopMediaQuery } from "hooks";
import backdropImg from "Components/Images/SET_BG2.jpg";
import { useCustomAppContext } from "contexts/CustomAppContext";
import { useMenuBarHeight } from "hooks/useMenuBarHeight";
import { FlexColumn } from "Components/Flex";

export const DefaultLayout = ({
  children,
  menu: MenuComponent = MenuBar,
  sidebar: SideBarComponent = SideBar,
  footer: FooterComponent = Footer,
  withSetLiveNotification = true,
}: {
  children: React.ReactNode;
  menu?: React.ComponentType;
  sidebar?: React.ComponentType;
  footer?: React.ComponentType;
  withSetLiveNotification?: boolean;
}) => {
  const isDesktop = useDesktopMediaQuery();
  const { menuBarHeight } = useMenuBarHeight();

  return (
    <Container>
      <MenuComponent />
      {!isDesktop && withSetLiveNotification && <SetLiveNotification />}
      <Body menuBarHeight={menuBarHeight}>
        <SideBarComponent />
        <Main>
          <Content>{children}</Content>
          <FooterComponent />
        </Main>
      </Body>
    </Container>
  );
};

export const TopBarLayout = ({
  children,
  menu: Menu = MenuBar,
  withFooter = false,
}) => {
  const { customApp } = useCustomAppContext();
  const { menuBarHeight } = useMenuBarHeight();

  return (
    <>
      {!customApp && (
        <Backdrop src={backdropImg} alt="background concert image" />
      )}
      <Container>
        <Menu />
        <Body menuBarHeight={menuBarHeight}>
          <Main>
            <Content>{children}</Content>
            {withFooter && <Footer />}
          </Main>
        </Body>
      </Container>
    </>
  );
};
const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

interface BodyProps {
  menuBarHeight: number;
}

const Body = styled.div<BodyProps>`
  position: relative;
  display: -webkit-inline-box;
  flex-grow: 1;

  ${({ theme }) => theme.media.mobile} {
    margin-top: ${({ menuBarHeight }) => menuBarHeight}px;
  }
`;
const Main = styled.div(
  () => css`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    position: relative;
  `,
  ({ theme }) => {
    if (!theme.custom) return null;
    const { background } = theme.custom.layout.content;
    return css`
      background: ${background};
    `;
  },
);

const Content = styled(FlexColumn)`
  flex-grow: 1;
  padding-bottom: 40px;
`;

const Backdrop = styled.img`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;
